import { __extends } from "tslib";
import React from 'react';
import { translate } from 'react-i18next';
import Arrow from '../../../../svgIcons/dist/components/arrow';
import Cross from '../../../../svgIcons/dist/components/cross';
import styles from './RectHeader.scss';
import { DEFAULT_HEADER_COLOR, DEFAULT_HEADER_TEXT_COLOR, } from '../../../../constants/default-widget-colors';
import classNames from 'classnames';
import _get from 'lodash/get';
import HeaderDetails from '../HeaderDetails/HeaderDetails';
import withTheme from '../../../../providers/theme/withTheme';
import { expandCollapseManager } from '../../../..';
var RectHeader = /** @class */ (function (_super) {
    __extends(RectHeader, _super);
    function RectHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RectHeader.prototype.render = function () {
        var _a, _b;
        var _c = this.props, clickable = _c.clickable, onClickBack = _c.onClickBack, onCancel = _c.onCancel, isExpanded = _c.isExpanded, onlineTitle = _c.onlineTitle, onlineMessage = _c.onlineMessage, avatar = _c.avatar, isHeaderFolded = _c.isHeaderFolded, hideCollapseButton = _c.hideCollapseButton, shouldApplyFoldAnimation = _c.shouldApplyFoldAnimation, shouldApplyUnfoldAnimation = _c.shouldApplyUnfoldAnimation, toggleHeaderFolded = _c.toggleHeaderFolded, theme = _c.theme, isMobile = _c.isMobile, shouldApplyExpandAnimation = _c.shouldApplyExpandAnimation, shouldApplyCollapseAnimation = _c.shouldApplyCollapseAnimation, availabilityStatus = _c.availabilityStatus, onProfileClick = _c.onProfileClick, menu = _c.menu, t = _c.t, typicallyReplies = _c.typicallyReplies;
        var backgroundColor = _get(theme, 'header.background', DEFAULT_HEADER_COLOR);
        var headerTextColor = _get(theme, 'header.textColor', DEFAULT_HEADER_TEXT_COLOR);
        var collapsedAsRounded = _get(theme, 'header.collapsedAsRounded', false);
        var headerArrowButtonClasses = classNames((_a = {},
            _a[styles.arrowIcon] = true,
            _a[styles.shouldApplyExpandAnimation] = shouldApplyExpandAnimation,
            _a[styles.shouldApplyCollapseAnimation] = shouldApplyCollapseAnimation,
            _a));
        var expandCollapseButton = null;
        if (isExpanded && !hideCollapseButton) {
            expandCollapseButton = (React.createElement("button", { className: styles.headerButton + " " + styles.collapseButton, onClick: expandCollapseManager.collapse, "data-hook": "collapse-button", "aria-label": t('header.collapseButtonAriaLabel') },
                React.createElement(Cross, { size: "12px", className: "collapseAsCross" })));
        }
        else if (!isExpanded) {
            expandCollapseButton = (React.createElement("button", { className: styles.headerButton + " " + styles.expandButton, "aria-labelledby": "header-title", "data-hook": "expand-button" },
                React.createElement("div", { className: headerArrowButtonClasses },
                    React.createElement(Arrow, { width: "14px", height: "8px" }))));
        }
        var backButton = (React.createElement("button", { className: styles.backButton + " " + styles.headerButton, onClick: onClickBack, "data-hook": "back-button", "aria-label": t('header.backButtonAriaLabel') },
            React.createElement(Arrow, { width: "14px", height: "8px" })));
        var cancelButton = (React.createElement("button", { className: styles.headerButton + " " + styles.cancelButton, onClick: onCancel, "data-hook": "cancel-button" }, t('header.cancelButton')));
        var headerStyle = {
            backgroundColor: backgroundColor,
            color: headerTextColor,
            fontFamily: _get(theme, 'header.fontFamily'),
        };
        var headerWrapperClasses = classNames((_b = {},
            _b[styles.wrapper] = true,
            _b[styles.expanded] = isExpanded,
            _b[styles.folded] = isHeaderFolded,
            _b[styles.unfolded] = !isHeaderFolded,
            _b[styles.shouldApplyFoldAnimation] = shouldApplyFoldAnimation,
            _b[styles.shouldApplyUnfoldAnimation] = shouldApplyUnfoldAnimation,
            _b));
        var shouldShowBackButton = isExpanded && onClickBack;
        var shouldShowCancelButton = isExpanded && onCancel;
        var shouldShowMenuButton = isExpanded && menu;
        return (React.createElement("div", { "data-hook": "rect-header", className: headerWrapperClasses, onClick: function () { return (!isExpanded ? expandCollapseManager.expand() : null); }, style: headerStyle },
            shouldShowBackButton && backButton,
            React.createElement(HeaderDetails, { clickable: clickable, hasBackButton: !!onClickBack, onlineTitle: onlineTitle, onlineMessage: onlineMessage, avatar: avatar, backgroundColor: backgroundColor, isHeaderFolded: isHeaderFolded, shouldApplyFoldAnimation: shouldApplyFoldAnimation, shouldApplyUnfoldAnimation: shouldApplyUnfoldAnimation, toggleHeaderFolded: toggleHeaderFolded, isExpanded: isExpanded, onProfileClick: onProfileClick, shouldApplyExpandAnimation: shouldApplyExpandAnimation && collapsedAsRounded, availabilityStatus: availabilityStatus, typicallyReplies: typicallyReplies }),
            expandCollapseButton,
            shouldShowCancelButton && cancelButton,
            shouldShowMenuButton && menu));
    };
    return RectHeader;
}(React.Component));
export default translate()(withTheme(RectHeader));
//# sourceMappingURL=RectHeader.js.map